import { render, staticRenderFns } from "./case-profile.vue?vue&type=template&id=545151d1&"
import script from "./case-profile.vue?vue&type=script&lang=ts&"
export * from "./case-profile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports